const Urls = {
  login: 'bitleague/register/login', //登录
  forgotPassword: 'bitleague/register/forgotpassword',//忘记密码
  resetPassword: 'bitleague/register/resetpassword',//重置密码
  userPassword: 'bitleague/users/resetpassword',//重置密码
  register: 'bitleague/register/register',//注册

  sendCode: 'bitleague/users/sendsms',//发送验证码
  bindmobile: 'bitleague/users/bindmobile',//发送验证码
  emailverify: 'bitleague/register/emailverify',//验证邮箱
  emailverifyPass: 'bitleague/register/emailverifypass',//验证邮箱pass
  emailverifycode: 'bitleague/register/emailverifycode',//验证邮箱code
  user_apply: 'bitleague/users/user_apply',//用户注册
  user_info: 'bitleague/users/user_info',//用户注册
  kyc_apply: 'bitleague/users/kyc_apply',//kyc 用户信息
  kyc_info: 'bitleague/users/kyc_info',//kyc 用户信息
  kba: 'bitleague/users/getKBA',
  kba_apply: 'bitleague/users/kba_apply',
  bindssn: 'bitleague/register/emailverifyssn',//提交 ssnemail
  /*btc 地址管理*/
  addAdress: 'bitleague/address/addresscreate',//添加地址
  addressList: 'bitleague/address/addresslist',//地址列表
  addressDel: 'bitleague/address/addresscancel',//删除地址
  /*invite*/
  claim: 'bitleague/users/claim',
  invite: 'bitleague/users/sendinviteemail',//发送邀请email
  /*account*/
  myaccounts: 'bitleague/account/myaccounts',
  history: 'bitleague/account/history',
  otcHistory: 'bitleague/otc/history',
  /*产品*/

  product: 'bitleague/termdeposit/product',
  buyPro: 'bitleague/termdeposit/ordercreate',
  /*冲提币*/
  deposit: 'bitleague/account/receive',//冲币
  withdraw: 'bitleague/account/send',//取出
  //inout
  inout: 'bitleague/account/historyinout',
  otcInout: 'bitleague/otc/historyinout',
  //order
  otcOrder: 'bitleague/account/historyorder',
  /*banner*/
  banner: 'bitleague/helper/banner',
  /*order cancel*/
  orderCancel: 'bitleague/termdeposit/ordercancel',
  historydetail: 'bitleague/account/historydetail',
  available: 'bitleague/register/regmail',
  /*上传文件*/
  uploadBase64: 'https://file.bitleague.com/index.php/app/fileupload/uploadbase64',
  uploadFile: 'https://file.bitleague.com/index.php/app/fileupload/upload/file',
  uploadfileAlone: 'bitleague/settings/uploadfile',  //单独上传文件
  uploadType: 'bitleague/helper/getUploadtype', //单独上传文件Type
  devicecancel:'bitleague/settings/devicecancel',//设备验证取消
  /*获取国家和电话*/
  country: 'bitleague/helper/getArea',
  /*银行列表*/
  countryBankList: 'bitleague/helper/getBankCountry',
  bankList: 'bitleague/bank/banklist',
  bankAdd: 'bitleague/bank/bankadd',
  bankDetail: 'bitleague/bank/bankdetail',
  bankDel: 'bitleague/bank/bankdel',
  otcbanklist: 'bitleague/bank/banklist',// otc银行卡下拉列表
  /*usd 充值提现*/
  usdWithdraw: 'bitleague/bank/withdraw',
  usdDeposit: 'bitleague/bank/deposit',
  otchistorydetail: 'bitleague/otc/historydetail',
  /*recuring*/
  recuringDel: 'bitleague/recurring/recurringdel',
  recuringSet: 'bitleague/recurring/recurringset',
  recuringList: 'bitleague/recurring/recurringlist',
  /*btc 买卖*/
  btcPrice: 'bitleague/helper/price',
  btcQuota: 'bitleague/trade/quota',
  btcSell: 'bitleague/trade/sell',
  btcBuy: 'bitleague/trade/buy',
  exchange: 'bitleague/helper/lines',
  info24h: 'bitleague/helper/info24h',

  cancelorder: 'bitleague/account/cancelorder', //pending列表下的 cancel
  otcCancelOrder: 'bitleague/trade/historycancel',//otc pending 下的cancel
  otOrderCancelOrder: 'bitleague/trade/ordercancel',//otc order 下的cancel
  otOrder: 'bitleague/trade/order',//otc order下单接口

  exchangefrom: 'bitleague/account/exchangefrom', //Cryptocurrency 下拉列表
  exchangeto: 'bitleague/account/exchangeto', //funding From 下拉列表

  // borrow
  getLtv: '/bitleague/borrow/borrowLTV',
  getTerm: '/bitleague/borrow/borrowTERM',
  getRate: '/bitleague/borrow/borrowRATE',
  getBorrw: '/bitleague/borrow/getloan',
  borrowHistory: '/bitleague/borrow/history',
  loanHistoryAdd: '/bitleague/borrow/loanHistoryAdd',
  borrowApply: '/bitleague/borrow/loanapply',
  borrowSign: '/bitleague/borrow/loanSign',
  loanapply: '/bitleague/borrow/loanapply',
  loancancel: '/bitleague/borrow/loancancel',
  getsign: '/bitleague/borrow/getsign',

  //depositintro啦数据
  getFixedValue: 'bitleague/helper/getFixedValue',

  //plaid
  getPlaid: 'bitleague/plaid/getaccount',
  getaccountsave: 'bitleague/plaid/getaccountsave',
  //首页公告
  notice: '/bitleague/helper/notice',


  //添加信用卡
  resourceTokenHash: 'bitleague/primetrust/resourceTokenHash', //获得token
  addCreditCard: 'bitleague/primetrust/addCreditCard', //来增加新的账号

  //谷歌登录
  oauth2signin: '/service/connect/googlesignin',

  //facebook添加email
  facebooksignin: 'service/connect/facebooksignin',

  //security
  get_security: 'bitleague/security/get_security',
  set_security: 'bitleague/security/set_security',
  setOTGSecret: '/bitleague/security/setOTGSecret',

  verifySecuritySMS: 'bitleague/security/verifySMS/VERIFYSECURITY',//security提交短信验证
  resendSecuritySMS: 'bitleague/security/resendSMS/VERIFYSECURITY',//security获取短信验证

  verifySecurityEmail: 'bitleague/security/verifyEMAIL/VERIFYSECURITY',//security提交email验证
  resendSecurityEmail: 'bitleague/security/resendEMAIL/VERIFYSECURITY',//security获取email验证

  verifyWithdrawCheckOTG: 'bitleague/security/checkOTG',//security验证OTG初始设置
  verifySecurityOTGCode: 'bitleague/security/verifyOTGCode/VERIFYSECURITY',//security提交谷歌验证

  verifySMS: 'bitleague/verify/verifySMS',//提交手机号sms
  resendSMS: 'bitleague/verify/resendSMS_no',//重新发送短信
  resendEMAIL: 'bitleague/verify/resendEMAIL',//login重新发送email
  verifyEMAIL: 'bitleague/verify/verifyEMAIL',//login提交验证码email
  verifyOTGCode: 'bitleague/verify/verifyOTGCode',//login提交谷歌验证

  resendWithdrawSMS: 'bitleague/security/resendSMS/WITHDRAW_SECURITYSETTING',//withdraw重新发送短信sms
  verifyWithdrawSMS: 'bitleague/security/verifySMS/WITHDRAW_SECURITYSETTING',//withdraw提交验证码sms
  resendWithdrawEMAIL: 'bitleague/security/resendEMAIL/WITHDRAW_SECURITYSETTING',//withdraw重新发送email
  verifyWithdrawEMAIL: 'bitleague/security/verifyEMAIL/WITHDRAW_SECURITYSETTING',//withdraw提交验证码email
  verifyWithdrawOTGCode: 'bitleague/security/verifyOTGCode/WITHDRAW_SECURITYSETTING',//withdraw提交谷歌验证

  deviceverify: 'bitleague/settings/deviceverify',//验证邮件
  sendverifyemail: 'bitleague/settings/sendverifyemail',//发送邮件接口
  devicelist: 'bitleague/settings/devicelist',//设备列表接口

  notifications: 'bitleague/settings/notifications',//BTC价格列表接口
  webscoketurl: 'wss://wss.bitleague.com',//webscoket路径

  unsubscribe:'bitleague/helper/unsubscribe',

    //mint
    mintOrderList:"bitleague/mint/orderList",
    mineHistoryList:"bitleague/mint/historyList",
    productdetail:'bitleague/mint/productdetail',
    mintproductlist:"bitleague/mint/productlist",
    mintcreateOrder:"/bitleague/mint/createOrder",
    mintwithdraw:"bitleague/mint/mintwithdraw"
}

export { Urls }



// WEBPACK FOOTER //
// ./src/util/url.js